import angular from "angular";
import moment from "moment";
import { ApiClient } from "@topline/services/apiService";
import { GridStateService } from "./components/common/gridState/gridStateService";
import { DraftForecastListComponent } from "./components/dashboards/draftForecastListComponent";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ImsDataService } from "./services/initializeAndRefresh/imsDataService";
import { ForecastService } from "./services/forecastService";

class ForecastConfig {
    static $inject = ["$stateProvider", "$urlRouterProvider"];

    constructor(private $stateProvider: ng.ui.IStateProvider, private $urlRouterProvider: ng.ui.IUrlRouterProvider) {
        this.init();
    }

    private init() {
        this.$stateProvider
            .state("forecast", {
                abstract: true,
                resolve: {
                    translateReady: [
                        angularServicesNames.$translate,
                        ($translate: ng.translate.ITranslateService) => $translate.onReady()
                    ]
                }
            })
            .state("forecast.list", {
                url: "^/forecast/list",
                template: require("./forecastList.html"),
                controller: "ForecastListCtrl",
                controllerAs: "$ctrl",
                redirectTo: "forecast.list.draft",
                resolve: {
                    imsLatestData: [ImsDataService.componentName, (imsDataService: ImsDataService) => imsDataService.getLatestData(undefined)]
                }
            })
            .state("forecast.list.draft", {
                url: "^/forecast/list/draft",
                component: DraftForecastListComponent.componentName,
                resolve: {
                    forecastFilter: [
                        GridStateService.componentName,
                        (gridStateService: GridStateService) => gridStateService.getItem("draftForecastListFilterState")
                    ]
                }
            })
            .state("forecast.list.created", {
                url: "^/forecast/list/created?budgetVersionUId&budgetYear",
                component: "createdForecastList",
                resolve: {
                    forecastFilter: [
                        GridStateService.componentName,
                        (gridStateService: GridStateService) =>
                            gridStateService.getItem("createdForecastListFilterState")
                    ],
                    versions: [
                        ApiClient.componentName,
                        "$stateParams",
                        (apiClient: ApiClient, $stateParams: ng.ui.IStateParamsService) =>
                            apiClient.getBudgetVersionsForYear($stateParams.budgetYear || moment().year() + 1)
                    ]
                }
            })
            .state("forecast.edit", {
                url: "^/forecast/edit/{id:int}",
                template: require("./forecastEdit.html"),
                controller: "ForecastEditCtrl",
                controllerAs: "$ctrl",
                resolve: {
                    forecastMetadata: [
                        ForecastService.componentName,
                        "$stateParams",
                        "responseHandlerService",
                        (
                            forecastService: ForecastService,
                            $stateParams: ng.ui.IStateParamsService,
                            responseHandlerService: $TSFixMe
                        ) =>
                            forecastService
                                .get($stateParams.id)
                                .then(response =>
                                    responseHandlerService.navigateWhenStatuses(response, [403], "unauthorized")
                                )
                    ],
                    imsLatestData: [
                        ImsDataService.componentName,
                        "$stateParams",
                        (imsDataService: ImsDataService, $stateParams: ng.ui.IStateParamsService) =>
                            imsDataService.getLatestData($stateParams.id)
                    ]
                }
            })
            .state("forecast.marketDump", {
                url: "^/forecast/market-dump/{id:int}",
                template: require("./forecastMarketDump.html"),
                controller: "ForecastMarketDumpCtrl",
                controllerAs: "$ctrl",
                resolve: {
                    forecastMarketDump: [
                        ForecastService.componentName,
                        "$stateParams",
                        "responseHandlerService",
                        (
                            forecastService: ForecastService,
                            $stateParams: ng.ui.IStateParamsService,
                            responseHandlerService: $TSFixMe
                        ) =>
                            forecastService
                                .getForecastMarketDump($stateParams.id)
                                .then(response =>
                                    responseHandlerService.navigateWhenStatuses(response, [403], "unauthorized")
                                )
                    ]
                }
            });
    }
}

angular.module("topline.modules").config(ForecastConfig);
